
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-addresses",
      function () {
        return require("private-next-pages/manage-addresses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-addresses"])
      });
    }
  